import { render } from "./WorkflowSettingsCardTypeColorPicker.vue?vue&type=template&id=4cc97bfe&scoped=true"
import script from "./WorkflowSettingsCardTypeColorPicker.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingsCardTypeColorPicker.vue?vue&type=script&lang=js"

import "./WorkflowSettingsCardTypeColorPicker.vue?vue&type=style&index=0&id=4cc97bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc97bfe"]])

export default __exports__